import { render } from "./JobImage.vue?vue&type=template&id=5489e7fc&scoped=true"
import script from "./JobImage.vue?vue&type=script&lang=js"
export * from "./JobImage.vue?vue&type=script&lang=js"

import "./JobImage.vue?vue&type=style&index=0&id=5489e7fc&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5489e7fc"]])

export default __exports__